module.exports = __webpack_public_path__ + "img/Steve-Shibu.52fea634.jpg";